/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class RevenuecatSubscriptions {
    'productIdentifier': string;
    'expiresDate': Date;
    'store': string;
    'originalPurchaseDate': Date;
    'unsubscribeDetectedAt': Date;
    'refundedAt': Date;
    'entitlement': string;
    'gracePeriodExpiresDate': Date;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "productIdentifier",
            "baseName": "productIdentifier",
            "type": "string",
            "format": ""
        },
        {
            "name": "expiresDate",
            "baseName": "expiresDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "store",
            "baseName": "store",
            "type": "string",
            "format": ""
        },
        {
            "name": "originalPurchaseDate",
            "baseName": "originalPurchaseDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "unsubscribeDetectedAt",
            "baseName": "unsubscribeDetectedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "refundedAt",
            "baseName": "refundedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "entitlement",
            "baseName": "entitlement",
            "type": "string",
            "format": ""
        },
        {
            "name": "gracePeriodExpiresDate",
            "baseName": "gracePeriodExpiresDate",
            "type": "Date",
            "format": "date-time"
        }    ];

    static getAttributeTypeMap() {
        return RevenuecatSubscriptions.attributeTypeMap;
    }

    public constructor() {
    }
}

